module.exports = __webpack_public_path__ + "img/auditResults.50e98740.svg";